<template>
  <div>
    <nav
      style="
        --bs-breadcrumb-divider: url(
          &#34;data:image/svg+xml,
          %3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E
          %3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E
          %3C/svg%3E&#34;
        );
      "
      aria-label="breadcrumb"
    >
      <ol class="breadcrumb">
        <!-- 第一層：教材分類 -->
        <li class="breadcrumb-item">
          <router-link
            v-if="pagePath"
            :to="pagePath"
            class="breadcrumb-link"
          >
            {{ pageLabel }}
          </router-link>

          <span v-else>
            {{ pageLabel }}
          </span>
        </li>

        <!-- 第二層：年級分類 -->
        <li class="breadcrumb-item">
          <router-link
            v-if="categoryPath"
            :to="categoryPath"
            class="breadcrumb-link"
          >
            {{ categoryLabel }}
          </router-link>

          <span v-else>
            {{ categoryLabel }}
          </span>
        </li>

        <!-- 第三層：目前教材 -->
        <li
          class="breadcrumb-item active"
          aria-current="page"
        >
          {{ getText(props.book?.title_zh, props.book?.title_en) }}
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { ref, onMounted, computed, getCurrentInstance } from "vue";

export default {
  name: "BreadCrumb",

  props: ["book"],

  setup(props) {
    const route = useRoute();
    const breadcrumbList = ref([]);

    const { proxy } = getCurrentInstance();

    const currentLang = computed(() => proxy.$i18n.locale);

    const iconButtonLabels = {
      PhonicsPage: {
        zh: "發音拼讀",
        en: "Phonics",
        path: "/PhonicsPage",
      },

      ReadingPage: {
        zh: "語文閱讀",
        en: "Reading",
        path: "/ReadingPage",
      },

      LanguageArtsPage: {
        zh: "文法寫作",
        en: "Lang Arts",
        path: "/LanguageArtsPage",
      },

      MathPage: {
        zh: "數學教材",
        en: "Math",
        path: "/MathPage",
      },

      SciencePage: {
        zh: "自然科學",
        en: "Science",
        path: "/SciencePage",
      },

      SocialPage: {
        zh: "社會人文",
        en: "Social",
        path: "/SocialPage",
      },

      ApPage: {
        zh: "AP",
        en: "AP",
        path: "/ApPage",
      },

      IbPage: {
        zh: "IB",
        en: "IB",
        path: "/IbPage",
      },

      WorldLanguagePage: {
        zh: "其他語言",
        en: "World Lang",
        path: "/WorldLanguagePage",
      },

      SWCamp: {
        zh: "綜合&寒暑假",
        en: "Camps",
        path: "/SWCamp",
      },

      SatTofelPage: {
        zh: "考試用書",
        en: "Test Prep",
        path: "/SatTofelPage",
      },

      ReferencePage: {
        zh: "讀本&字典",
        en: "Readers & Dictionaries",
        path: "/ReferencePage",
      },
    };

    const getText = (zh, en) => {
      return currentLang.value === "zh"
        ? zh || en || ""
        : en || zh || "";
    };

    const pageKey = computed(() => {
      return breadcrumbList.value?.[0] || "";
    });

    const pageLabel = computed(() => {
      if (!pageKey.value) return "";

      const labelObj = iconButtonLabels[pageKey.value];

      if (!labelObj) {
        return pageKey.value;
      }

      return currentLang.value === "zh"
        ? labelObj.zh || labelObj.en || ""
        : labelObj.en || labelObj.zh || "";
    });

    const pagePath = computed(() => {
  if (!pageKey.value) return "";

  return `/ProductsPage/${pageKey.value}`;
});

    const categoryLabel = computed(() => {
      return getText(
        props.book?.category_zh,
        props.book?.category_en
      );
    });

    const categoryPath = computed(() => {
      if (!pagePath.value || !categoryLabel.value) {
        return "";
      }

      return {
        path: pagePath.value,
        query: {
          category: categoryLabel.value,
        },
      };
    });

    onMounted(() => {
      breadcrumbList.value = route.fullPath
        .split("/")
        .filter(Boolean)
        .slice(1);
    });

    return {
      props,
      breadcrumbList,
      pageLabel,
      pagePath,
      categoryLabel,
      categoryPath,
      getText,
    };
  },
};
</script>

<style scoped>
.breadcrumb {
  margin-bottom: 1rem;
}

.breadcrumb-item {
  font-size: 14px;
}

.breadcrumb-link {
  color: #00489b;
  text-decoration: none;
}

.breadcrumb-link:hover {
  color: #003875;
  text-decoration: underline;
}

.breadcrumb-item.active {
  color: #495057;
}
</style>